import { useTranslation } from 'react-i18next';
import { ReactComponent as AlertTriangleIcon } from 'src/assets/tailwind/alert-triangle.svg';
import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from 'src/components/ui/dialog';
import { Icon } from 'src/components/ui/icon';
import type { UploadSessionConflictModalProps } from 'src/content/DataLibrary/UploadSession/types';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

const UploadSessionConflictModal = ({
  open,
  onOpenChange,
  onOkay
}: UploadSessionConflictModalProps) => {
  const { t } = useTranslation();

  const handleOkay = () => {
    onOkay?.();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hideDefaultClose className="tw:max-w-110 tw:gap-0 tw:p-0">
        <DialogHeader
          showBorder={false}
          className="tw:items-center tw:pt-2xl tw:pb-xl tw:px-2xl"
        >
          <Icon
            icon={AlertTriangleIcon}
            sizeClass="tw:h-2xl tw:w-2xl"
            colorClass="tw:text-icon-warning"
          />
          <DialogTitle className="tw:text-center">
            {t(T.sameFilesUploadingTitle)}
          </DialogTitle>
          <DialogDescription className="tw:text-center tw:text-text-secondary">
            {t(T.sameFilesUploadingDescription)}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="tw:justify-end!">
          <Button hierarchy="primary" size="medium" onClick={handleOkay}>
            {t(T.okay)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UploadSessionConflictModal;
